export interface ResourceConfiguration {
  cpu: number;
  memory: number;
  disk: number | null;
}

export const DEFAULT_RESOURCE_CONFIG: ResourceConfiguration = {
  cpu: 4,
  memory: 4,
  disk: null,
};

export const PRESET_CONFIGS = {
  small: { cpu: 4, memory: 8, disk: null },
  medium: { cpu: 6, memory: 16, disk: null },
  large: { cpu: 8, memory: 64, disk: 128 },
  xlarge: { cpu: 16, memory: 128, disk: 512 },
};

// Helper function to check if resource configuration is default
export const isDefaultResourceConfiguration = (
  config: ResourceConfiguration,
): boolean => {
  return config.cpu === 4 && config.memory === 4 && config.disk === null;
};

// Helper function to get selected preset name
export const getSelectedPreset = (
  config: ResourceConfiguration,
): string | null => {
  for (const [presetName, preset] of Object.entries(PRESET_CONFIGS)) {
    if (
      config.cpu === preset.cpu &&
      config.memory === preset.memory &&
      config.disk === preset.disk
    ) {
      return presetName.charAt(0).toUpperCase() + presetName.slice(1);
    }
  }
  return null;
};

// Helper function to format disk display text
export const formatDiskDisplayText = (disk: number | null): string => {
  return disk ? `${disk}GB` : "Default disk";
};
